"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var DelayWrapper = (function (_super) {
    tslib_1.__extends(DelayWrapper, _super);
    function DelayWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            shouldRender: false
        };
        return _this;
    }
    DelayWrapper.prototype.componentDidMount = function () {
        var _this = this;
        this.renderTimeout = setTimeout(function () {
            _this.setState({ shouldRender: true });
        }, this.props.delay);
    };
    DelayWrapper.prototype.componentWillUnmount = function () {
        clearTimeout(this.renderTimeout);
    };
    DelayWrapper.prototype.render = function () {
        var children = this.props.children;
        return this.state.shouldRender ? children : null;
    };
    return DelayWrapper;
}(React.Component));
exports.default = DelayWrapper;
DelayWrapper.defaultProps = {
    delay: 1000,
};
